import {useCallback, useState} from 'react';
import {useResize} from 'core/hooks/useResize';

export const useCheckScreenMedia = (mediaQuery: boolean, screenWidth: number) => {
    const [isMatched, setIsMatched] = useState<boolean>(mediaQuery);
    const handleWindowResize = useCallback(() => setIsMatched(window.innerWidth < screenWidth), [screenWidth]);

    useResize(handleWindowResize);

    return isMatched;
};
